exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".I3H- {\n    display: block;\n    animation: _2gAa 1.4s linear infinite;\n    margin: 0 auto;\n}\n\n@keyframes _2gAa {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(270deg);\n    }\n}\n\n.e11w {\n    stroke-dasharray: 187;\n    stroke-dashoffset: 0;\n    transform-origin: center;\n    animation: Z0k- 1.4s ease-in-out infinite;\n}\n\n@keyframes Z0k- {\n    0% {\n        stroke-dashoffset: 187;\n    }\n    50% {\n        stroke-dashoffset: 46.75;\n        transform: rotate(135deg);\n    }\n    100% {\n        stroke-dashoffset: 187;\n        transform: rotate(450deg);\n    }\n}\n", ""]);

// exports
exports.locals = {
	"spinner": "I3H-",
	"rotator": "_2gAa",
	"path": "e11w",
	"dash": "Z0k-"
};